(function($, window) {
    "use strict";

    if (document.location.href.indexOf('cmsPreview') < 0) {
        return;
    }

    window.mobilePreview = window.mobilePreview ? window.mobilePreview : {};

    /**
     * @const
     */
    var CSS_ID = '#mobile-style-template';

    var $templateStyle;

    function createStyle(url) {
        return $('<link id="' + CSS_ID + '" href="' + url + '" rel="stylesheet" type="text/css" />');
    }

    window.mobilePreview.templateselector = {

        init:function(){
            $templateStyle = $(CSS_ID);

            return this;
        },

        changeTemplate:function(templateUrl){
            if (templateUrl) {
                this.updateTemplate(templateUrl);
            }
        },

        updateTemplate:function(templateUrl){
            if ($templateStyle) {
                $templateStyle.remove();
            }

            $templateStyle =  createStyle(templateUrl).appendTo("head");
        }
    };

    window.mobilePreview.mobiletemplatestatus = {
        init: function() {
            return;
        }
    }

})(jQuery, window);



/*****************
 ** WEBPACK FOOTER
 ** ./webserver/document_root/s/js/web/mobile/mobileTemplateSelector.js
 ** module id = 3861
 ** module chunks = 100
 **/